export const AppConstants = {
  APP_ROUTES: {
    forecastWindspeed: 'extremeweather/windspeed/10/akbm',
    forecastWindspeedSidebar: 'extremeweather/windspeed/24/akbm',
    forecastRainfall: 'extremeweather/rainfall/10/akbm',
    forecastRainfallSidebar: 'extremeweather/rainfall/24/akbm',
    actualRainfall: 'observedweather/rainfall-actual/24/akbm',
    heatWave: 'heatwatch/heatwave',
    flowForecast: 'floodforecast/gis/akbm',
    forecastTemperature: '/extremeweather/temperature/24/akbm',
    forecastHumidity: '/extremeweather/humidity/24/akbm',
    actualWindSpeed: '/observedweather/windspeed-actual/24/akbm',
    actualTemperature: '/observedweather/temperature-actual/24/akbm',
    actualHumidity: '/observedweather/humidity-actual/24/akbm',
    drought: '/drought/gis/akbm',
    drinkingWaterStress: '/drinkingwaterstress/gis/akbm',
    rainfallActual: 'rainfallActual',
    // thunderstorm: '/thunderstorms/thunderstorm/akbm',
    nowcast:'/nowcastlogin',
    dryspell:'/dryspelllogin',
    windSpeed:'/weatherforecast/wind-speed-forecast',
    observedRainfall:'/weatherforecast/rainfall-actual',
    rfForecast:'weatherforecast/rainfall-forecast',
    coldWave:'/coldwatches/coldwave'
  },
  WIDGETS_MAPS: {
    actualRainfall: {
      isActive: false,
      id: 'actualRainfall'
    },
    // thunderstorm: {
    //   isActive: true,
    //   id: 'thunderstorm'
    // },
      coldWave: {
      isActive: false,
      id: 'coldWave'
    },
    nowcast: {
      isActive: false,
      id: 'nowcast'
    },
    windSpeed: {
      isActive: false,
      id: 'windSpeed'
    },
    observedRainfall:{
      isActive: false,
      id: 'observedRainfall'
    },
    rfForecast:{
      isActive: false,
      id: 'rfForecast'
    },
    forecastRainfall: {
      isActive: false,
      id: 'forecastRainfall'
    },
    heatWave: {
      isActive: false,
      id: 'heatWave'
    },
    forecastWindspeed: {
      isActive: false,
      id: 'forecastWindspeed'
    },
    flowForecast: {
      isActive: false,
      id: 'flowForecast'
    },
    rainfallactual: {
      isActive: false,
      id: 'rainfallActual'
    },
  },
  COMPONENT_THROBBER_MAP: {
    actualRainfall: 'throbberAR',
    forecastRainfall: 'throbberFR',
    heatWave: 'throbberHW',
    forecastWindspeed: 'throbberFW',
    flowForecast: 'throbberFF',
    rainfallactual: 'throbberFF'
  }
};
